import React from "react"
import { buildRow, hideModal } from "../../util/FormatUtil";

interface HL7PreviewModalState{

}

interface HL7PreviewModalProps{
    selectedMessage
}



class HL7PreviewModal extends React.Component<HL7PreviewModalProps, HL7PreviewModalState>{
    public static ID = "HL7PreviewModal"
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    formatFinalHL7(){
        if(!this.props.selectedMessage.FinalHL7){
            return <p>No message content stored.</p>
        }
        // One segment per line - works for any message type (OML orders, ORU results)
        const segments = this.props.selectedMessage.FinalHL7.split(/\r\n|\r|\n/).filter(seg => seg.trim().length > 0);
        return (
            <pre style={{whiteSpace: 'pre-wrap', wordBreak: 'break-all'}}>
                {segments.join('\n')}
            </pre>
        );
    }

    render() {
        return (
        <>
            <div className="modal fade form_modal" id={HL7PreviewModal.ID} tabIndex={-1} role="dialog"
                 aria-label="HL7 Message Preview"
                 aria-hidden="true">
                <div className="modal-dialog modal-lg modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="container-fluid  min-vh-10">
                                <div className={"row"}>
                                    <div className="col-12 pt-2">
                                        <div className="card mb-2">
                                            <div className="card-header verlag-bold">
                                                <h4 style={{fontWeight: 'bold'}}>HL7 Message Preview
                                                    <button style={{outline: 'none'}}  type="button" className="close pr-4" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true" style={{fontSize: '1.5em', fontWeight: 'bold'}}>&times;</span>
                                                    </button>
                                                </h4>
                                            </div>
                                            <div className="card-body">
                                                <p>{this.props.selectedMessage.FinalFHS}</p>
                                                <p>{this.props.selectedMessage.FinalBHS}</p>
                                                {this.formatFinalHL7()}
                                                <p>{this.props.selectedMessage.FinalBTS}</p>
                                                <p>{this.props.selectedMessage.FinalFTS}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer mb-2 mr-2 ml-0" style={{backgroundColor: 'transparent', borderTop: 'none'}}>
                                    <button type="button"  className={'btn btn-primary float-right'} onClick={() => hideModal(HL7PreviewModal.ID)}>Ok</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
        )
    }
}

export default HL7PreviewModal;